import { render, staticRenderFns } from "./DichVuVeDienTuForm.vue?vue&type=template&id=bc7a3bbe&scoped=true"
import script from "./DichVuVeDienTuForm.vue?vue&type=script&lang=js"
export * from "./DichVuVeDienTuForm.vue?vue&type=script&lang=js"
import style0 from "./DichVuVeDienTuForm.vue?vue&type=style&index=0&id=bc7a3bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7a3bbe",
  null
  
)

export default component.exports